import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowTaskDefinitionModel from '../../../models/WorkflowTaskDefinitionModel';
import DataService from "../../../services/data.service";
import Step_popup_AddTask from "../Popups/Step_popup_AddTask"

export type Props = {
    workflowDefinitionId: number
    workflowStepDefinitionId: number
}

const Step_tab_Tasks: React.FC<Props> = ({ workflowDefinitionId, workflowStepDefinitionId }) => {
    const [data, setData] = useState<WorkflowTaskDefinitionModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { isAuthorizedForWorkflowDefinition } = useAuth();


    useEffect(() => {
        getTableData();
    }, [workflowStepDefinitionId]);

    function getTableData() {
        DataService.get<WorkflowTaskDefinitionModel[]>('api/v1/WorkflowTaskDefinitions/ByWorkflowStepDefinition/' + workflowStepDefinitionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData: WorkflowTaskDefinitionModel): boolean {
        return isAuthorizedForWorkflowDefinition(ApplicationFunctions.UpdateWorkflowDefinition, rowData.workflowStepDefinition.workflowDefinitionId)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowTaskDefinitions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <DataTable
                name='dtWorkflowEventCodeTasks'
                tableData={data}
                navigateTitle='Workflow task'
                navigateUrl='/plm/WorkflowSetup/WorkflowTask/'
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { title: 'Order', dataProp: 'taskOrder', sort: 'asc' },
                    { title: 'Name', dataProp: 'name' },
                    { title: 'Type', dataProp: 'taskType' },
                    { title: 'Category', dataProp: 'taskCategory' },
                    { title: 'Assign to a', dataProp: 'assignToFunctionalRole' },
                    { title: 'Duration', dataProp: 'duration' },
                    { title: 'Required', dataProp: 'isRequired', dataType: 'bool', trueValue: 'Yes', falseValue: 'No' },
                    { title: 'Forewards workflow', dataProp: 'forwardsWorkflow', dataType: 'bool', trueValue: 'Yes', falseValue: 'No' },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions: [ApplicationFunctions.UpdateWorkflowDefinition] }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
                    }
                ]}
            />
            {showPopup && <Step_popup_AddTask show={showPopup} onHide={() => { getTableData(); setShowPopup(false) }} workflowDefinitionId={workflowDefinitionId} workflowStepDefinitionId={workflowStepDefinitionId} />}

        </>
    );
}
export default Step_tab_Tasks;